import { render } from "./HiViewLoading.vue?vue&type=template&id=99c39d8e"
import script from "./HiViewLoading.vue?vue&type=script&lang=js"
export * from "./HiViewLoading.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__